import { useState, useEffect } from 'react';
import useClientHydrated from '@charlietango/use-client-hydrated';

function useWindowSize() {
  var clientHydrated = useClientHydrated();

  var _useState = useState(clientHydrated ? {
    width: window.innerWidth,
    height: window.innerHeight
  } : {
    width: 0,
    height: 0
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  useEffect(function () {
    function handleSize() {
      setWindowSize(function (prevState) {
        // Don't create a new state object if the size didn't change (e.g. after initial render)
        return prevState.height !== window.innerHeight || prevState.width !== window.innerWidth ? {
          width: window.innerWidth,
          height: window.innerHeight
        } : prevState;
      });
    }

    handleSize();
    window.addEventListener('resize', handleSize);
    return function () {
      window.removeEventListener('resize', handleSize);
    };
  }, []);
  return windowSize;
}

export default useWindowSize;
